import {
  NpsDetailsModalContainer, type NpsDetailsModalProps,
} from '~/_shared/components/rating/npsDetailsModal.container';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    NpsDetails: NpsDetailsModalProps;
  }
}

modalRenderer.register('NpsDetails', NpsDetailsModalContainer);
